export default "__VITE_ASSET__YrVP_rZ8__"